import { QcPlanByAnalyteOrInstrument } from '../../../contracts/qc-plan/qc-plan-detail.model';
import { QcPlanAnalyteName } from '../../../contracts/qc-plan/qc-plan-detail.model';

export interface IQcPlanDetailState {
    qcPlanDetail: QcPlanByAnalyteOrInstrument;
}

const initialState: IQcPlanDetailState = {
    qcPlanDetail: {
            'studyTestDataId': 0,
            'aOrI': 'A',
            'whichPlan': 'A',
            'analyte': {
                'analyte': '',
                'method': '',
                'reagent': '',
                'matrix': '',
                'unit': ''
            },
            'instrument': {
                'instrument': '',
                'labNumber': 0,
                'labInstrumentId': 0
            },
            'levels': [],
            'planDetail': []
    }
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/qc-plan/IQcPlanDetailState.ts